import { render, staticRenderFns } from "./GalleryGridUI.vue?vue&type=template&id=b7d5a17a&scoped=true"
import script from "./GalleryGridUI.vue?vue&type=script&lang=ts"
export * from "./GalleryGridUI.vue?vue&type=script&lang=ts"
import style0 from "./GalleryGridUI.vue?vue&type=style&index=0&id=b7d5a17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d5a17a",
  null
  
)

export default component.exports